import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const projectGql = gql`
  query Project($projectId: ID!) {
    project(id: $projectId) {
      _id
      name
      url

      page {
        _id
        name

        components {
          _id
          
          component {
            _id
            type
            name
          }

          attributes {
            _id
            key
            type
            value
          }
        }
      }

      theme {
        _id

        fonts {
          primary {
            family
            variant
          }
        }

        colors {
          primary { r g b a }
          black { r g b a }
          white { r g b a }
        }

        elevation
        roundness
        spacing
      }
    }

    components {
      _id
      type
      name
    }

    integrations {
      google {
        webfonts {
          family
          variants
        }
      }
    }
  }
`

export const project = graphql(projectGql, {
  options(props) {
    return {
      variables: {
        projectId: props.match.params.projectId
      },
      fetchPolicy: 'network-only'
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/Project/queries.js